import React, { useState } from 'react';
import JobList from './JobList';
import JobDetail from './JobDetail';
import SearchBar from './SearchBar';
import './JobPortal.css';

const JobPortal: React.FC = () => {
  const [selectedJobId, setSelectedJobId] = useState<number | null>(null);
  const [searchFilters, setSearchFilters] = useState({
    keyword: '',
    country: '',
    city: '',
    state: '',
    recruitingOnly: true
  });

  const handleJobSelect = (jobId: number) => {
    setSelectedJobId(jobId);
  };

  const handleBackToList = () => {
    setSelectedJobId(null);
  };

  const handleSearch = (filters: { keyword: string; country: string; city: string; state: string; recruitingOnly: boolean }) => {
    setSearchFilters(filters);
    setSelectedJobId(null); // 搜索时回到列表页
  };

  return (
    <div className="job-portal">
      <main className="portal-main">
        {selectedJobId ? (
          <JobDetail jobId={selectedJobId} onBack={handleBackToList} />
        ) : (
          <>
            <SearchBar onSearch={handleSearch} />
            <JobList 
              searchFilters={searchFilters} 
              onJobSelect={handleJobSelect} 
            />
          </>
        )}
      </main>
    </div>
  );
};

export default JobPortal;
